import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { Box, Typography, CircularProgress, Grid } from "@mui/material";
import Loader from "../../../../../../SAPPages/components/Loader/Loader";
import NoDataAvailabWithNoCardleScreen from "../../../../../components/screens/NoDataAvailabeWithNoCard";

export default function OverAllWiseProgress({
  overallData,
  testTypeData,
  loading,
}) {

  console.log("overallData", overallData);

  // State for the chart data and loading state
  const [columnChartData, setColumnChartData] = useState({
    series: [
      {
        name: "Completion",
        data: [],
      },
    ],
    options: {
      chart: {
        type: "bar", // Column chart
        height: 245,
        toolbar: { show: false },
      },
      plotOptions: {
        bar: {
          borderRadius: 5,
          horizontal: false, // Vertical bars (column chart)
          dataLabels: {
            position: "top", // Data labels above each column
          },
          borderRadiusApplication: "end",
          columnWidth: "30px",
          distributed: true,
        },
      },
      colors: ["#D78D2F", "#507BB9", "#4DAE92", "#ED8363", "#56A6DB"], // Example colors
      dataLabels: {
        enabled: false,
      },
      xaxis: {
        categories: [],
        title: {
          //   text: 'Tasks',
          style: {
            fontSize: "14px",
            fontWeight: 500,
            color: "#222222",
            fontFamily: "Inter",
          },
        },
      },
      yaxis: {
        title: {
          //   text: 'Completion Percentage',
          style: {
            fontSize: "14px",
            fontWeight: "bold",
            color: "#4f4f4f",
          },
        },
        max: overallData?.marksRange?.max, // Maximum value for Y-axis
      },
      tooltip: {
        enabled: true,
        y: {
          formatter: function (val) {
            return `${val} / ${overallData?.marksRange?.max}`;
          },
        },
      },
      legend: {
        show: false, // Hide legend
      },
    },
  });

  // Fetch data from API when the component mounts
  useEffect(() => {
    // Example API URL

     const tasks =
    overallData?.overallData?.map(item => item.section) || [];
const completion =
    overallData?.overallData?.map(item => item.band) || [];
    // Set the chart data
    setColumnChartData({
      ...columnChartData,
      series: [
        {
          name: "Band",
          data: completion, // Set dynamic data
        },
      ],
      options: {
        ...columnChartData.options,
        xaxis: {
          ...columnChartData.options.xaxis,
          categories: tasks, // Set dynamic categories (tasks)
        },
        yaxis: {
          ...columnChartData.options.yaxis,
          max: overallData?.marksRange?.max, // Maximum value for Y-axis
        },
        tooltip: {
          ...columnChartData.options.tooltip,
          y: {
            formatter: function (val) {
              return `${val} / ${overallData?.marksRange?.max}`;
            },
          },
        },
      },
    });
  }, [overallData]);

  const redirectionLink1 = "/test-prep/performance/my-exam";
  const handleRedirect = () => {
    localStorage.setItem("defaultExamData", JSON.stringify(testTypeData));
    window.open(redirectionLink1, "_blank");
  };

  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Typography
            fontFamily="Inter"
            color="#161719"
            sx={{ fontWeight: 600, fontSize: "18px" }}
          >
            Overall Wise Progress
          </Typography>
        </Grid>

        {loading ? (
          <Grid item xs={12}>
            <Loader text="Loading Overall Details..." height="30vh" />
          </Grid>
        ) : !loading && overallData?.overallData?.length > 0 ? (
          <Grid item xs={12}>
            <Chart
              options={columnChartData.options}
              series={columnChartData.series}
              type="bar"
              height={245}
            />
          </Grid>
        ) : (
          <NoDataAvailabWithNoCardleScreen
            topImage={
              <img src="/newdashboard/performance/20769812_Sandy_Bus-25_Single-04 1 (1).png" />
            }
            //  text="No Test Type Purchased Yet"
            subText="You haven’t completed the test yet.Finish the test to view your results."
            buttonName="Complete Test"
            // buttonIcon={
            //   <Icon icon="material-symbols:crown-rounded" />
            // }
            imageSize={120}
            showTopImage={true}
            redirectionLink={handleRedirect}
          />
        )}
      </Grid>
    </>
  );
}
